module.exports = __webpack_public_path__ + "static/media/pagseguro-logo.e32a3832.png";